export const UPDATE_INSTALL_MESSAGE_STATE = 'UPDATE_INSTALL_MESSAGE_STATE';
export const UPDATE_SIDE_NAV_STATE = 'UPDATE_SIDE_NAV_STATE';
export const UPDATE_SITE_TITLE = 'UPDATE_SITE_TITLE';